module.exports = __webpack_public_path__ + "static/img/untreated.ca86a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/untreated.png
// module id = Vpzk
// module chunks = 1